"use strict";
module.exports = {
    entityModel: 'copackAgreement',
    events: {
        COPACK_AGREEMENT_CREATED: 'COPACK_AGREEMENT_CREATED',
        COPACK_AGREEMENT_UPDATED: 'COPACK_AGREEMENT_UPDATED',
    },
    actions: {
        get: 'v1.copackAgreement.get',
        list: 'v1.copackAgreement.list',
        upsert: 'v1.copackAgreement.upsert',
        upsertWhenEmpty: 'v1.copackAgreement.upsertWhenEmpty',
        updateWhenEmpty: 'v1.copackAgreement.updateWhenEmpty',
        update: 'v1.copackAgreement.update',
    },
    serviceAgreements: {
        'v2.5': 'v2.5',
        v3: 'v3',
        articlesOwnedByFlaivy: 'articlesOwnedByFlaivy',
    },
    settlementPeriods: {
        weekly: 'weekly',
        monthly: 'monthly',
        fullAndHalfMonth: 'fullAndHalfMonth',
    },
};
